var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.isReadOnly
    ? _c("div", { staticClass: "form-group" }, [
        !_vm.disabled
          ? _c(
              "div",
              [
                _c(
                  "button",
                  {
                    directives: [
                      {
                        name: "tooltip",
                        rawName: "v-tooltip.top.center",
                        value: {
                          content: _vm.$t(
                            "ContinuousReport.TargetGroupsAndOperation.AddTargetGroups_Instructions"
                          )
                        },
                        expression:
                          "{ content: $t('ContinuousReport.TargetGroupsAndOperation.AddTargetGroups_Instructions') }",
                        modifiers: { top: true, center: true }
                      }
                    ],
                    staticClass: "btn btn-secondary",
                    attrs: { type: "button" },
                    on: { click: _vm.showModal }
                  },
                  [
                    _vm._v(
                      "\n      " +
                        _vm._s(
                          _vm.$t(
                            "ContinuousReport.TargetGroupsAndOperation.AddTargetGroups"
                          )
                        ) +
                        "\n    "
                    )
                  ]
                ),
                _vm._v(" "),
                _c("add-target-group-dialog", {
                  attrs: {
                    id: _vm.dialogId,
                    targetGroups: _vm.targetGroups,
                    targetGroupCount: _vm.targetGroupCount,
                    max: _vm.max
                  },
                  on: { select: _vm.select, add: _vm.add }
                })
              ],
              1
            )
          : _c(
              "div",
              { staticClass: "d-inline-block", attrs: { tabindex: "0" } },
              [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-secondary",
                    attrs: {
                      type: "button",
                      disabled: "",
                      "aria-disabled": "true"
                    }
                  },
                  [
                    _vm._v(
                      "\n      " +
                        _vm._s(
                          _vm.$t(
                            "ContinuousReport.TargetGroupsAndOperation.AddTargetGroups"
                          )
                        ) +
                        "\n    "
                    )
                  ]
                )
              ]
            )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }